// import React from 'react'

// import styles from './Hero.module.css';


// function Hero() {
//   return (
//     <div className="hero">
//       <div className={styles['hero-text']}>
//         <h1>
//           Tired of Endless Job Searching? <br />
//           Find Your Dream Role, Faster with AI.
//         </h1>
//         <p>
//           The world's most powerful job search engine, built with cutting-edge AI and Search. <br></br>
//           Find that hidden gem in the haystack.
//         </p>
//       </div>
//     </div>
//   )
// }

// export default Hero;


import React from 'react'
import styles from './Hero.module.css';

function Hero({ heroText }) {
  return (
    <div className="hero">
      <div className={styles['hero-text']}>
        <div dangerouslySetInnerHTML={{ __html: heroText }} />
        {/* <p>
          The world's most powerful job search engine, built with cutting-edge AI and Search. <br />
          Find that hidden gem in the haystack.
        </p> */}
      </div>
    </div>
  )
}

export default Hero
